class QuestionsPopup extends ModalDialog {
  constructor() {
    super();
    this.displayMode = this.dataset.displayMode || 'popup';
    this.cookieName = 'questions-popup-' + this.dataset.sectionId;
    this.dismissed = getCookie(this.cookieName);
    this.form = this.querySelector('form');
    this.allowedPages = this.dataset.pages ? this.dataset.pages.split(',').map(s => s.trim()).filter(Boolean) : [];
    this.ageVerificationPopup = document.querySelector('age-verification-popup');
    this.formView = this.querySelector('.questions-popup__form-view');
    this.successView = this.querySelector('.questions-popup__success-view');

    if (this.form) {
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    // FAB lives outside this element, find it by ID
    if (this.displayMode === 'floating' && this.dataset.fabId) {
      this.fab = document.getElementById(this.dataset.fabId);
      if (this.fab) {
        this.fab.addEventListener('click', this.togglePopup.bind(this));
      }
    }
  }

  connectedCallback() {
    super.connectedCallback();

    if (this.checkContactPosted()) return;

    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === 'true') {
        this.show();
      }
      return;
    }

    if (this.dismissed !== null) {
      if (this.fab) this.fab.style.display = 'none';
      return;
    }

    if (!this.isAllowedPage()) {
      if (this.fab) this.fab.style.display = 'none';
      return;
    }

    if (this.displayMode === 'floating') return;

    var delay = (this.dataset.delay || 5) * 1000;

    if (this.ageVerificationPopup) {
      let prevClassState = this.classList.contains('newsletter-popup-is-hidden');
      var popup = this;

      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName == 'class') {
            var currentClassState = mutation.target.classList.contains('newsletter-popup-is-hidden');
            if (prevClassState !== currentClassState) {
              prevClassState = currentClassState;
              if (!currentClassState) {
                setTimeout(() => {
                  if (popup.dismissed !== null) return;
                  popup.show();
                }, delay);
              }
            }
          }
        });
      });
      observer.observe(this, { attributes: true });
    } else {
      setTimeout(() => {
        if (this.dismissed !== null) return;
        this.show();
      }, delay);
    }
  }

  checkContactPosted() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('contact_posted') !== 'true') return false;

    setCookie(this.cookieName, 'submitted', 365);
    this.showSuccessView();
    this.show();

    if (this.fab) this.fab.style.display = 'none';

    var url = new URL(window.location);
    url.searchParams.delete('contact_posted');
    url.hash = '';
    window.history.replaceState({}, '', url.pathname + url.search);

    return true;
  }

  showSuccessView() {
    if (this.formView) this.formView.style.display = 'none';
    if (this.successView) this.successView.style.display = '';
  }

  isAllowedPage() {
    if (this.allowedPages.length === 0) return true;
    var path = window.location.pathname;
    return this.allowedPages.some(function (page) {
      if (page === '/') return path === '/';
      return path === page || path.startsWith(page + '/') || path.startsWith(page + '?');
    });
  }

  togglePopup() {
    if (this.hasAttribute('open')) {
      this.hide();
    } else {
      this.show();
    }
  }

  show(opener) {
    super.show(opener);
    if (this.fab) this.fab.style.display = 'none';
  }

  hide() {
    super.hide();
    if (this.displayMode === 'floating') {
      if (this.fab) this.fab.style.display = '';
    } else {
      setCookie(this.cookieName, 'closed', 30);
    }
  }

  onSubmit() {
    setCookie(this.cookieName, 'submitted', 365);
  }
}

customElements.define('questions-popup', QuestionsPopup);
